import React from 'react'
//import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import md5 from 'react-native-md5'
import Spinner from './Spinner'
import 'bootstrap/dist/css/bootstrap.min.css'
import Popup from 'reactjs-popup'
import { Input } from '@material-ui/core'
import Alert from '@material-ui/lab/Alert'
//import Loader from 'react-loader-spinner'
//import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css'

const imgStyle = {
  width: '200px',
  height: '200px',
  marginLeft: '30px',
}

const spanStyle = {
  fontWeight: 'bold',
  fontSize: '30px',
}

const divStyle = {
  display: 'inline-block',
  textAlign: 'center',
}

const div2Style = {
  display: 'inline-block',
}

const h2Style = {
  display: 'none',
}

const aStyle = {
  display: 'none',
}

class Details extends React.Component {
  constructor(props) {
    super(props)
    if (this.props.employee) {
      this.state = {
        open: false,
      }
    }
    this.openModal = this.openModal.bind(this)
    this.closeModal = this.closeModal.bind(this)
  }

  openModal() {
    this.setState({ open: true })
  }
  closeModal() {
    this.setState({ open: false })
  }

  renderTeams() {
    const myData = [].concat(Object.values(this.props.employee.employee.teams))
    return Object.keys(myData).map((key) => {
      const team = myData[key]
      return <li key={key}>{team['name']}<span style={{ display: team['manager'] === true ? 'inline' : 'none'}}>( Manager )</span></li>
    }
    )
  }

  handleClickModal(){
    this.openModal()
  }

  handleSaveModal(){
    const oldp = document.getElementById('currpass')
    const newp = document.getElementById('newpass')
    const confp = document.getElementById('confnewpass')
    //console.log(this.props.oncall.team.id + ', ' + this.state.date + ', ' + iduserchange)
    //console.log(oldp.value + ' ' + newp.value)
    const formData = new FormData()
    formData.append('id', this.props.employee.employee.id)
    formData.append('old_password', oldp.value)
    formData.append('new_password', newp.value)
    formData.append('confirm_password', confp.value)
    const urlf = '/api/v1/change_password'
    const meth = 'POST'
    fetch(urlf, {
      method: meth,
      body: formData,
    })
    .then(response => response.json())
    .then((data) => {
      if (data.type === 'user'){
        document.getElementById('mylink').click()
      } else if (data.type === 'errorconf'){
        $('#myerrorconf').show()
        console.error('err' + data)
      } else {
        $('#myerror').show()
        console.error('err' + data)
      }
    })
    .catch((err) => {
      console.error('Error while changing password! ' + err)
    })
  }

  render() {
    if (this.props.employee.employee) {
      const empl = this.props.employee.employee
      const gravatarId = md5.hex_md5(empl['email_downcase'])
      const l = 'http://gravatar.com/emails'
      const lf = '/users/' + empl['id']
      //const ld = '/update_password/' + empl['id']
      return <div><p style={spanStyle}>{empl.name}</p><a href={lf} id="mylink" style={aStyle}></a><Popup open={this.state.open} onClose={this.closeModal}><div className="passwordmodal" style={{margin: '25px'}}><a className="close" onClick={this.closeModal}>X</a><div id="myerror" style={h2Style}><Alert color="error">There was a problem. Please try again!</Alert></div><div id="myerrorconf" style={h2Style}><Alert color="error">Password confirmation must be the same with the new password! Please try again!</Alert></div><h3>Change password</h3><div className="col-sm-12" style={{float: 'left', paddingLeft: '0px'}}><div><div>Current password:<Input type="password" id="currpass" style={{marginLeft: '10px'}}></Input></div><div>New password:<Input type="password" id="newpass" style={{marginLeft: '10px'}}></Input></div><div>Confirm new password:<Input type="password" id="confnewpass" style={{marginLeft: '10px'}}></Input></div><a href="#" id="savechangepass" className="btn btn-secondary btn-sm col-sm-12" style={{marginTop: '10px'}} onClick={() => this.handleSaveModal()}>Save change</a><br /><br /></div></div></div></Popup><div className="row"><div style={divStyle} className="col-sm-5 col-lg-5 col-md-5"><img src={'https://secure.gravatar.com/avatar/' + gravatarId + '?s=200'} alt={empl.name} className="gravatar" style={imgStyle} /></div><div style={div2Style} className="col-sm-5 col-lg-5 col-md-5"><p><b>Email:</b> {empl.email}</p><div><b>Teams:</b><ul>{this.renderTeams()}</ul></div><a href={l} className="btn btn-secondary col-sm-4" rel="noopener noreferrer" target="_blank">Change photo</a><a href="#" className="btn btn-secondary col-sm-6 offset-sm-2" onClick={() => this.handleClickModal()}>Change password</a></div></div></div>
    }
    //console.log(this.props.employee)
    return <div><Spinner></Spinner></div>
  }
}

Details.propTypes = {
  employee: PropTypes.object.isRequired,
}

export default Details
